import { useCallback } from 'react'
import { defaults } from 'lodash'
import { useLocalStorage } from 'usehooks-ts'

export const OverrideVariables = {
  PrioritizeOnDemandCBOName: 'prioritizeOnDemandCBOName',
}

const initialValue = {
  [OverrideVariables.PrioritizeOnDemandCBOName]: process.env.VITE_PRIORITIZE_ON_DEMAND_CBO || '',
}

const getDefaulted = (settings) => defaults(settings, initialValue)

export default function useOverrideVariables() {
  const [variables, setVariables] = useLocalStorage('variables-override', initialValue)

  const update = useCallback(
    (variables = {}) => {
      setVariables((current) => ({ ...getDefaulted(current), ...variables }))
    },
    [setVariables]
  )

  return [getDefaulted(variables), update]
}
